import { useContext, useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { FileUpload } from "primereact/fileupload";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { Toast } from "primereact/toast";

import { iniciarTour2, stopTour } from "../services/demoDriver";

import Dashboard from "../Layout/Dashboard";
import { Link, useNavigate, useParams } from "react-router-dom";
import FormSubHeading from "../components/FormSubHeading";
import RoleWrapper from "../components/RoleWrapper";
import {
  currencyFormat,
  dateDiffFromNow,
  formatCi,
  formatDateString,
  formatFullNumber,
  readableSex,
} from "../utils";

import {
  useSingleMedicalCase,
  useGetInsurance,
  useMedicalCenterClientRequirements,
  useCanAddRequirementsToCase,
  useCanAddRequirementsCallCenter,
  // useStaleMedicalCases,
} from "../hooks/queries";
import { UserRole } from "../constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { BASE_URL, CaseStatus } from "../constants";
import { ChangeStatusSingleModal } from "../components/StatusChangeModal";
import { usePatchMedicalCase } from "../hooks/mutations";
import {
  addMedicalOrderToCase,
  addRequirements,
  deleteMedicalCaseInvoice,
  updateCaseRequirementsDone,
  deleteMedicalCaseFile,
} from "../services/medicalCases";
import StatusTag from "../components/StatusTag";
import "./CaseDetail.css";
import HospitalPendingModal from "./HospitalPendingModal";
import { useSuscribeCaseToPendingMutation } from "../hooks/mutations";
import AssignedCaseDetail from "./SubAdministrator/AssignedCaseDetail";
import CaseDetailDisplayStatus from "./CaseDetailDisplayStatus";
import { InputTextarea } from "primereact/inputtextarea";
import { MultiSelect } from "primereact/multiselect";
import { ToastContext } from "../ToastContext";
import { InputNumber } from "primereact/inputnumber";
import { Messages } from "primereact/messages";

// import { Timeline } from "primereact/timeline";
import ChangeMedicalCenterDialog from "./Subscribe/ChangeMedicalCenterDialog";
import RemesarCaseDialog from "./Modals/RemesarCasoDialog";

import ConciliarCaseDialog from "./Modals/ConciliarCaseDialog";
import GenerateClaimDialog from "./Modals/GenerateClaimDialog";

// @CITA MEDICA
// import HospitalPendingConsultationModal from "./HospitalPendingConsultationModal";
// import DoctorSelectionModal from "./DoctorSelectionModal";
import {
  useConsultDoctorsQuery,
  useCitaMedicaBookings,
} from "../hooks/queries";
import DoctorSelectionModal from "../MedicalStaff/DoctorSelectionModal";
import { useCitaMedicaBookingsMutation } from "../hooks/mutations";
import { medicalCaseGenerateSiniestro } from "../services/medicalCases";

// PDF con detalles del caso médico
// @DLL_BUTTON
// import { getExternalOrder } from "../services/medicalCases";
// import { exportCaseDetailToPDF } from "./exportExternal";

/**
 * Detalle del caso médico
 * @param {object} props
 * @param {string?} props.backButtonUrl
 */
export default function CaseDetail({ backButtonUrl }) {
  const [isDemoMode, setIsDemoMode] = useState(
    localStorage.getItem("demoMode") === "true"
  );

  // Buscar detalle del caso
  const { caseId } = useParams();

  const { data, isLoading } = useSingleMedicalCase(caseId);

  const role = localStorage.getItem("role");
  if (role === UserRole.SUB_ADMINISTRATOR && data?.children?.length) {
    return <AssignedCaseDetail data={data} backButtonUrl={backButtonUrl} />;
  }

  return (
    <Dashboard
      headerTitle="Detalle del caso"
      // backButtonUrl={backButtonUrl ?? "/casos"}
      dynamicGoBack
    >
      {role === UserRole.MEDICAL_CENTER && (
        <Button
          id="boton-tourg"
          className="mi-boton-demo"
          onClick={() => {
            const newMode = !isDemoMode;
            setIsDemoMode(newMode);
            //localStorage.setItem('demoMode', newMode.toString());

            if (newMode) {
              iniciarTour2();
            } else {
              stopTour();
              localStorage.removeItem("demoMode"); 
            }
          }}
        >
          {isDemoMode ? "Detener Demo" : "iniciar Demo"}
        </Button>
      )}
      {/* Botón Secundario (Solo toggle demo) 
    <Button 
      id="demobutton"
      label={isDemoMode ? "Apagar simulación" : "Modo simulación"}
      severity={isDemoMode ? "danger" : "help"}
      onClick={() => {
        const newMode = !isDemoMode;
        setIsDemoMode(newMode);
        localStorage.setItem('demoMode', newMode.toString());
      }}
      aria-pressed={isDemoMode}
    />
    */}

      {isLoading && <ProgressSpinner />}
      {/*  {data && !isLoading && <CaseDetailContent data={data} />} */}
      {data && !isLoading && (
        <CaseDetailContent
          data={data}
          isDemoMode={isDemoMode}
          setIsDemoMode={setIsDemoMode}
        />
      )}
      {!data && !isLoading && <p>No se encontró el caso médico</p>}
    </Dashboard>
  );
}

/**
 * Show detail when case is loaded
 * @param {object} props
 * @param {import("../services/medicalCases").MedicalCase} props.data
 */
function CaseDetailContent({ data, isDemoMode, setIsDemoMode }) {

  const [conciliationFiles, setConciliationFiles] = useState([]);
  const [showConciliarDialog, setShowConciliarDialog] = useState(false);
  // @DLL_BUTTON
  // const [printingOrder, setPrintingOrder] = useState(false); // Loader para imprimir orden

  const handleFileUpload = async (e, row) => {
    const file = e.target.files[0];
    if (!file) return;

    const TAMANO_MAXIMO_BYTES = 1 * 1024 * 1024; // 1MB
    const TIPOS_PERMITIDOS = ["application/pdf", "image/jpeg", "image/png"];

    if (!TIPOS_PERMITIDOS.includes(file.type)) {
      toastRef.current.show({
        severity: "error",
        summary: "Formato no permitido",
        detail: "Use PDF, JPG o PNG.",
      });
      return;
    }

    if (file.size > TAMANO_MAXIMO_BYTES) {
      toastRef.current.show({
        severity: "error",
        summary: "Tamaño excedido",
        detail: "El archivo no debe superar los 1MB.",
      });
      return;
    }

    try {
      const formDataDoc = new FormData();
      formDataDoc.append("file", file);
      formDataDoc.append("medical_case", data.id);

      const token = localStorage.getItem("token");
      const uploadResponse = await fetch(
        `${BASE_URL}insurance/medical-case-conciliate/`,
        {
          method: "POST",
          body: formDataDoc,
          headers: {
            Authorization: `Token ${token}`, // 👈 Añade esta línea
          },
        }
      );

      if (!uploadResponse.ok) throw new Error("Error al subir el documento");

      const uploadedFile = await uploadResponse.json();

      setConciliationFiles((prev) => [...prev, uploadedFile]);

      const storedFiles =
        JSON.parse(localStorage.getItem(`conciliationFiles_${data.id}`)) || [];
      storedFiles.push(uploadedFile);
      localStorage.setItem(
        `conciliationFiles_${data.id}`,
        JSON.stringify(storedFiles)
      );

      toastRef.current.show({
        severity: "success",
        summary: "Éxito",
        detail: "Documento cargado automáticamente",
      });
    } catch (err) {
      toastRef.current.show({
        severity: "error",
        summary: "Error",
        detail: err.message || "Hubo un problema al cargar el documento.",
      });
    }
  };

  useEffect(() => {
    const loadConciliationFiles = async () => {
      // 1. Primero cargar desde localStorage (rápido)
      const storedFiles =
        JSON.parse(localStorage.getItem(`conciliationFiles_${data.id}`)) || [];
      setConciliationFiles(storedFiles);

      // 2. Luego sincronizar con el backend (para persistencia real)
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${BASE_URL}insurance/medical-case-conciliate/?case_id=${data.id}`,
          {
            headers: {
              Authorization: `Token ${token}`, // <- Incluir el header
            },
          }
        );
        if (response.ok) {
          const serverFiles = await response.json();
          if (Array.isArray(serverFiles) && serverFiles.length > 0) {
            setConciliationFiles(serverFiles);
            localStorage.setItem(
              `conciliationFiles_${data.id}`,
              JSON.stringify(serverFiles)
            );
          }
        }
      } catch (error) {
        console.error("Error al cargar archivos de conciliación:", error);
      }
    };

    if (data.id) loadConciliationFiles();
  }, [data.id, showConciliarDialog]);

  const [requirementsDone, setRequirementsDone] = useState(
    data.requirements
      .filter((req) => req.is_done)
      .map((req) => ({
        id: req.id,
        requirement: req.requirement,
        is_done: req.is_done,
        amount: req.amount,
        quantity: Number(req.quantity),
      }))
  );

  const [unmarkedRequirements, setUnmarkedRequirements] = useState([]);

  useEffect(() => {
    // Obtener los IDs de los requisitos marcados
    const doneRequirementIds = requirementsDone.map((req) => req.id);

    // Filtrar los requisitos originales que no están en los marcados
    const unmarked = data.requirements
      .filter((req) => !doneRequirementIds.includes(req.id))
      .map((req) => ({
        id: req.id,
        name: req.requirement_name || `Requisito ${req.id}`,
        amount: req.amount,
        quantity: req.quantity,
        is_done: false,
      }));

    setUnmarkedRequirements(unmarked);
  }, [requirementsDone, data.requirements]);

  //const [isDemoMode, setIsDemoMode] = useState(localStorage.getItem('demoMode') === 'true');
  const [localCaseStatus, setLocalCaseStatus] = useState(data.status); // 👈 Nuevo estado

  const [showDemoDialog, setShowDemoDialog] = useState(false);
  const [originalStatus, setOriginalStatus] = useState(localCaseStatus);

  // 1. Añade un nuevo estado para controlar si está "atendido" en demo
  const [isDemoAttended, setIsDemoAttended] = useState(false);

  useEffect(() => {
    // Reiniciar todos los estados relacionados con demo cuando cambia el modo
    if (!isDemoMode) {
      setIsDemoAttended(false);
      setLocalCaseStatus(data.status); // Restaurar estado original del caso
      // También puedes reiniciar los requisitos si es necesario
    } else {
      // Al activar el modo demo, asegurarse de empezar desde cero
      setIsDemoAttended(false);
      setLocalCaseStatus(CaseStatus.PENDIENTE);
    }
  }, [isDemoMode, data.status]); // Dependencias del efecto

  // Función para manejar el agendamiento en demo
  const handleDemoSchedule = () => {
    setLocalCaseStatus(CaseStatus.RESCHEDULED); // Cambia el estado local
    toastRef.current.show({
      severity: "success",
      summary: "Éxito (Demo)",
      detail: "Caso agendado exitosamente en modo demostración",
    });
  };

  const role = localStorage.getItem("role");
  const userRole = localStorage.getItem("role");
  const showCompromiso =
    (data.service_id && data.is_active_rms) ||
    (!data.service_id && data.is_active_rms === false);
  // const staleCases = useStaleMedicalCases({ page: 1, filters: {} });
  // State for dialog
  const [showFileDialog, setShowFileDialog] = useState(false);
  const navigate = useNavigate();
  // State for medical files
  const [medicalFiles, setMedicalFiles] = useState(
    data.files.map((file) => ({
      id: file.id,
      file: file.file,
      fileName: file.file_name,
      fileType: file.type_requirement,
    }))
  );

  // State for invoice
  // const [invoiceFile, setInvoiceFile] = useState(null);

  // read changes in data
  const [invoice, setInvoice] = useState(
    data.invoice.map((invoice) => ({
      id: invoice.id,
      file: invoice.file,
      fileName: invoice.file_name,
    }))
  );

  // State for dialog
  const [showDialog, setShowDialog] = useState(false);
  const [showReqDoneDialog, setShowReqDoneDialog] = useState(false);
  const [showRemesadoDialog, setShowRemesadoDialog] = useState(false);

  const [showDialogPending, setShowDialogPending] = useState(false);
  const [showMedicalOrderDialog, setShowMedicalOrderDialog] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(data.status);
  const [showAnullateDialog, setShowAnullateDialog] = useState(false);
  const [showSubscribeDialog, setshowSubscribeDialog] = useState(false);
  const [showChangeMedicalCenterDialog, setShowChangeMedicalCenterDialog] =
    useState(false);
  const [messageSubscribeResponse, setMessageSubscribeResponse] = useState("");
  const msgs = useRef(null);

  // ================================================================= @CITAMEDICA Requirements that are Consultation type
  const [isHospitalPendingClosed, setIsHospitalPendingClosed] = useState(false);

  const [showDoctorSelectionModal, setShowDoctorSelectionModal] =
    useState(false); // Pop up asignando doctores
  const [consultationRequirements, setConsultationRequirements] = useState([]); // Requerimientos de consulta
  const specialtyIds = consultationRequirements.map((req) => req.requirement); // Especialidades que se enviaran al endpoint para obtener los doctores
  const { data: groupedDoctors, isLoading: loadingDoctors } =
    useConsultDoctorsQuery(specialtyIds); // doctores agrupados por especialidad
  const [bookingsDataState, setBookingsDataState] = useState([]); // Estado local para bookingsData
  const { data: bookingsData, isLoading: loadingBookings } =
    useCitaMedicaBookings(data.id);

  const [showGenerateClaimDialog, setShowGenerateClaimDialog] = useState(false); // Estado para mostrar el diálogo de generar siniestro

  const bookingMutation = useCitaMedicaBookingsMutation({
    onSuccess: ({ type, message }) => {
      if (type === "success") {
        toastRef.current.show({
          severity: "success",
          summary: "Éxito",
          detail: message,
        });
        queryClient.invalidateQueries({
          queryKey: ["medicalCase", data.id],
        });
      } else {
        toastRef.current.show({
          severity: "error",
          summary: "Error",
          detail: message,
        });
      }
    },
  });

  useEffect(() => {
    if (!loadingBookings && bookingsData) {
      setBookingsDataState(bookingsData); // Actualiza el estado local cuando bookingsData esté disponible
    }
  }, [bookingsData, loadingBookings]);
  const [responseSiniestroMessage, setResponsSiniestroMessage] = useState(null);

  const generateClaimMutation = useMutation({
    mutationFn: medicalCaseGenerateSiniestro,
    onSuccess: (data) => {
      if (data.isOk) {
        setResponsSiniestroMessage(
          `Siniestro Generado Nro de Siniestro: ${data.clave}`
        );
        queryClient.invalidateQueries({
          queryKey: ["medicalCase", Number(data.id)],
        });
        toastRef.current.show({
          severity: "success",
          summary: "Éxito",
          detail: "Siniestro Generado con Éxito",
        });
      } else {
        setResponsSiniestroMessage(
          "Error al generar el siniestro en el sistema administrativo, por favor comunicarse con el seguro."
        );
      }
    },
    onError: (error) => {
      setResponsSiniestroMessage(
        "Hubo un Error Generando el Siniestro. Por favor contactar al Seguro."
      );
    },
  });
  /**
   * El pop up de agendar que muestra el listado de especialidades antes de enviarlo al selector.
   */
  // const handleAcceptConsultation = () => {

  //   // console.log("Consultation Requirements", consultationRequirements);
  //   // console.log("GroupedDoctors", groupedDoctors);

  //   // Validate that groupedDoctors is not empty
  //   if (!groupedDoctors || Object.keys(groupedDoctors).length === 0 || consultationRequirements.length === 0) {
  //     toastRef.current.show({
  //       severity: "error",
  //       summary: "Error",
  //       detail: "No hay doctores disponibles para la consulta o no hay requerimientos de consulta.",
  //     });

  //     // handleAcceptHospitalPending();
  //     return;
  //   }

  //   // Check if some consultation requirements are missing doctors
  //   const missingSpecialties = consultationRequirements.filter(
  //     (req) => !groupedDoctors[req.requirement] || groupedDoctors[req.requirement].doctors.length === 0 || req.is_done
  //   );

  //   // If there are missing specialties, show a warning message
  //   if (missingSpecialties.length > 0 && missingSpecialties.length !== consultationRequirements.length) {
  //     const missingSpecialtyNames = missingSpecialties.map((req) => req.requirement_name).join(", ");
  //     toastRef.current.show({
  //       severity: "warn",
  //       summary: "Advertencia",
  //       detail: `No hay doctores disponibles para las siguientes especialidades: ${missingSpecialtyNames}.`,
  //     });
  //   } else if (missingSpecialties.length === consultationRequirements.length) {
  //     toastRef.current.show({
  //       severity: "warn",
  //       summary: "Advertencia",
  //       detail: "No hay doctores disponibles para las especialidades requeridas.",
  //     });

  //     // handleAcceptHospitalPending();
  //     return;
  //   }

  //   // Proceed to the doctor selection modal for the available specialties
  //   refetch(); // Ensure the latest data is fetched
  //   setShowDialogPending(false);
  //   setShowDoctorSelectionModal(true);
  // };

  // @changes When the HospitalPendingModal confirms
  // const handleAcceptHospitalPending = () => {

  //   caseMutation.mutate({
  //     caseId: data.id,
  //     data: { status: CaseStatus.RESCHEDULED },
  //   });

  //   if (showDialogPending) {
  //     setShowDialogPending(false);
  //   }
  // }

  /**
   * When the DoctorList Popup hits Confirmar
   */
  const handleConfirmDoctors = (selectedDoctors) => {
    console.log("[handleConfirmDoctors] Selected Doctors:", selectedDoctors);
    setShowDoctorSelectionModal(false);
    // @todo Handle the confirmation logic here (e.g., send data to the backend)
  };

  // Initialize state for requirement state
  useEffect(() => {
    setSelectedStatus(data.status);

    // if (groupedDoctors) {
    //   console.log("Grouped doctors updated:", groupedDoctors);
    //   // Perform any additional logic when groupedDoctors changes
    // }

    // Count requirement types that has type of requirement of 'CONSULTA'
    const _consultationRequirements = data.requirements
      .filter(
        (req) =>
          req.type_requirement?.toLowerCase() === "consulta" && !req.is_done
      )
      .map((req) => ({
        ...req,
        amount: req.amount_usd, // Use amount in USD if available, fallback to original amount
      }));

    setConsultationRequirements(_consultationRequirements);

    // Show DoctorSelectionModal only if:
    // - HospitalPendingModal is closed
    // - Doctors data has been loaded
    // - There are consultation requirements
    if (
      isHospitalPendingClosed &&
      !loadingDoctors && // Ensure doctorsQuery has been loaded
      _consultationRequirements.length > 0 &&
      Object.keys(groupedDoctors || {}).length > 0
    ) {
      setShowDoctorSelectionModal(true);
    }
  }, [data, groupedDoctors, isHospitalPendingClosed, loadingDoctors]);

  const toastRef = useRef(null);
  const dataRequirements = data?.requirements ?? [];
  // Change requirement done state
  const changeRequirementDone = (value) => {
    // const newRequirementsDone = requirementsDone.map((req) => {
    //   if (req.id === requirement) {
    //     return {
    //       ...req,
    //       is_done: done,
    //     };
    //   }
    //   return req;
    // });
    setRequirementsDone(value);
  };

  /**
   * Save medical file from dialog
   * @param {{ fileType: string, file: File & { objectURL: string } }} medicalFile
   */
  const onSaveMedicalFile = (medicalFile) => {
    setMedicalFiles((prev) => [...prev, medicalFile]);
  };

  const queryClient = useQueryClient();

  const caseMutation = usePatchMedicalCase({
    onSuccess: ({ type, message }) => {
      if (type === "success") {
        toastRef.current.show({
          severity: "success",
          summary: "Éxito",
          detail: message,
        });
        // @change fixed and used refetchType to active so it refresh
        queryClient.invalidateQueries({
          queryKey: ["medicalCase", Number(data.id)],
          refetchType: "active",
        });
        queryClient.invalidateQueries({
          queryKey: ["medicalCases", "stale"],
        });
      } else {
        toastRef.current.show({
          severity: "error",
          summary: "Error",
          detail: message,
        });
        setSelectedStatus(data.status);
      }
      setShowDialog(false);
      setShowRemesadoDialog(false);
      setShowAnullateDialog(false);
      setShowConciliarDialog(false);
    },
  });

  const requirementsDoneMutation = useMutation({
    mutationFn: updateCaseRequirementsDone,
    onSuccess: ({ type, message }) => {
      if (type === "success") {
        toastRef.current.show({
          severity: "success",
          summary: "Éxito",
          detail: message,
        });
        setShowReqDoneDialog(false);
        setShowRemesadoDialog(false);

        queryClient.invalidateQueries({
          queryKey: ["medicalCase", Number(data.id)],
        });
        queryClient.invalidateQueries({
          queryKey: ["medicalCases", "stale"],
        });

        // setSelectedStatus(CaseStatus.ATENDIDO);
      } else {
        toastRef.current.show({
          severity: "error",
          summary: "Error",
          detail: message,
        });
        setShowReqDoneDialog(false);
        setShowRemesadoDialog(false);
      }
    },
  });

  const suscribeCaseToPendingMutation = useSuscribeCaseToPendingMutation({
    onSuccess: ({ isOk, message }) => {
      setshowSubscribeDialog(true);
      if (message === "Asegurado No Existe") {
        setMessageSubscribeResponse("Paciente pendiente por suscribir");
        return;
      }
      setMessageSubscribeResponse(message);
    },
  });

  const deleteInvoiceMutation = useMutation({
    mutationFn: deleteMedicalCaseInvoice,
    onSuccess: ({ type, message, id }) => {
      if (type === "success") {
        toastRef.current.show({
          severity: "success",
          summary: "Éxito",
          detail: "Archivo eliminado con éxito",
        });
        queryClient.invalidateQueries({
          queryKey: ["medicalCase", data.id],
        });
        setInvoice((prev) => prev.filter((inv) => inv.id !== id));
      } else {
        toastRef.current.show({
          severity: "error",
          summary: "Error",
          detail: message,
        });
      }
    },
  });
  const deleteFileMutation = useMutation({
    mutationFn: deleteMedicalCaseFile,
    onSuccess: ({ type, message, id }) => {
      if (type === "success") {
        toastRef.current.show({
          severity: "success",
          summary: "Éxito",
          detail: "Archivo eliminado con éxito",
        });
        queryClient.invalidateQueries({
          queryKey: ["medicalCase", data.id],
        });
        setInvoice((prev) => prev.filter((inv) => inv.id !== id));
      } else {
        toastRef.current.show({
          severity: "error",
          summary: "Error",
          detail: message,
        });
      }
    },
  });

  /**
   * Show preview of an invoice file
   * @param {{ file: string, fileName: string } | undefined} row
   */
  const invoiceFilePreviewBody = (row) => {
    if (
      row?.fileName !== undefined &&
      (row.fileName?.endsWith(".jpeg") ||
        row.fileName?.endsWith(".jpg") ||
        row.fileName?.endsWith(".png"))
    ) {
      return (
        <img
          role="presentation"
          src={row.file}
          alt={row.fileName}
          width={80}
        ></img>
      );
    } else {
      return <></>;
    }
  };

  /**
   * Show actions for a medical file
   * @param {{ file: string, fileName: string }} row
   */
  const medicalFileActionBody = (row) => (
    <div className="flex align-content-center gap-1">
      <Button
        label="Ver"
        className="max-w-fit"
        outlined
        onClick={() => window.open(row.file, "_blank")}
      />
      {(data.status === CaseStatus.PENDIENTE ||
        data.status === CaseStatus.ATENDIDO ||
        data.status === CaseStatus.RESCHEDULED ||
        data.status === CaseStatus.REMESADO) &&
        (role === UserRole.MEDICAL_CENTER || role === UserRole.LABORATORY) && (
          <Button
            label="Eliminar"
            className="max-w-fit"
            outlined
            text
            severity="danger"
            aria-label="Eliminar"
            onClick={() => {
              console.log(row);
              setMedicalFiles((prev) => {
                return prev.filter((file) => file.file !== row.file);
              });

              if (row.id) {
                // Delete file

                if (row.fileType) {
                  deleteFileMutation.mutate({ fileId: row.id });
                } else {
                  deleteInvoiceMutation.mutate({ invoiceId: row.id });
                }
              }
            }}
          />
        )}
    </div>
  );

  const medicalFileNameLinkBody = (row) => (
    <Button
      className="text-left"
      label={row.fileName || row.file_name}
      link
      onClick={() => window.open(row.file, "_blank")}
    />
  );

  const conciliationFileActionBody = (row) => (
    <div className="flex align-content-center gap-1">
      <Button
        label="Ver"
        className="max-w-fit"
        outlined
        onClick={() => window.open(row.file, "_blank")}
      />
      {data.status === CaseStatus.CONCILIADO && role === UserRole.MASTER && (
        <>
          <Button
            label="Eliminar"
            className="max-w-fit"
            outlined
            severity="danger"
            onClick={async () => {
              try {
                const token = localStorage.getItem("token");
                const response = await fetch(
                  `${BASE_URL}insurance/medical-case-conciliate/${row.id}/`,
                  {
                    method: "DELETE",
                    headers: {
                      Authorization: `Token ${token}`,
                    },
                  }
                );

                if (!response.ok) throw new Error("Error al eliminar");

                setConciliationFiles((prev) =>
                  prev.filter((file) => file.id !== row.id)
                );

                const storedFiles =
                  JSON.parse(
                    localStorage.getItem(`conciliationFiles_${data.id}`)
                  ) || [];
                localStorage.setItem(
                  `conciliationFiles_${data.id}`,
                  JSON.stringify(storedFiles.filter((f) => f.id !== row.id))
                );

                toastRef.current.show({
                  severity: "success",
                  summary: "Éxito",
                  detail: "Documento eliminado",
                });
              } catch (error) {
                toastRef.current.show({
                  severity: "error",
                  summary: "Error",
                  detail: error.message,
                });
              }
            }}
          />

          {!row.file && ( // Mostrar botón de cargar si no hay archivo
            <Button
              label="Cargar"
              className="max-w-fit"
              outlined
              onClick={() => setShowConciliarDialog(true)}
            />
          )}
        </>
      )}
    </div>
  );

  /**
   * Show toast for successful upload
   */
  const onUpload = () => {
    toastRef.current.show({
      severity: "success",
      summary: "Éxito",
      detail: "Archivo subido con éxito",
    });
  };

  const handleDemoUpload = () => {
    setInvoice([
      {
        file: `${BASE_URL}dummy-invoice.jpg`,
        fileName: "factura-demo.jpg",
        id: "demo-invoice",
      },
    ]);

    toastRef.current.show({
      severity: "success",
      summary: "Simulación exitosa",
      detail: "Factura cargada en modo demo",
      life: 3000,
    });
  };

  const notAtentStatuses = [
    CaseStatus.PENDIENTE,
    CaseStatus.TO_REVIEW,
    CaseStatus.TO_SUBSCRIBE,
    CaseStatus.RESCHEDULED,
    CaseStatus.ANULADO,
    CaseStatus.WITHOUT_FUNDS,
  ];

  // @DLL_BUTTON
  // async function handlePrintExternalOrder(data, toastRef) {

  //   setPrintingOrder(true);

  //   try {

  //     const result = await getExternalOrder(data.id);

  //     if (
  //       result &&
  //       result !== null &&
  //       result.external_order_id !== null &&
  //       result.external_order_id !== undefined
  //     ) {
  //       const updatedData = { ...data, external_order_id: result.external_order_id };
  //       await exportCaseDetailToPDF(updatedData);

  //     } else {
  //       toastRef.current.show({
  //         severity: "error",
  //         summary: "Error",
  //         detail: "No se pudo generar la orden. Intente más tarde.",
  //         life: 3000,
  //       });
  //     }
  //   } finally {
  //     setPrintingOrder(false);
  //   }
  // }

  return (
    <div className="p-fluid">
      {isDemoMode && (
        <div className="demo-banner-improved">
          <div className="demo-banner-content">
            <i className="pi pi-info-circle demo-banner-icon"></i>
            <span className="demo-banner-text">
              📢 Estás en modo demo — Las acciones no afectan los datos reales
            </span>
          </div>
        </div>
      )}

      {data?.status === CaseStatus.PENDIENTE && (
        <HospitalPendingModal
          visible={showDialogPending}
          isDemoMode={isDemoMode} // ← Pasa la prop
          setIsDemoMode={setIsDemoMode} // ← Pasa la prop
          onHide={() => {
            // if (showDialogPending) setShowDialogPending(false);
            setShowDialogPending(false);
            setIsHospitalPendingClosed(true); // Marca el modal como cerrado
          }}
          patientName={data.patient_.name}
          phoneNumber={data.patient_.phone}
          daysLeft={3 - dateDiffFromNow(new Date(data.created_at))}
          caseId={data.id}
          toastRef={toastRef}
          demoMode={isDemoMode} // Pasamos el estado del modo demo
          onScheduleDemo={handleDemoSchedule} // Callback para demo
        />
      )}

      {/* Fin del popup de agendar */}

      {/* @CITAMEDICA Popup de selección de doctores */}
      <DoctorSelectionModal
        visible={showDoctorSelectionModal}
        onHide={() => setShowDoctorSelectionModal(false)}
        consultationRequirements={consultationRequirements}
        groupedDoctors={groupedDoctors}
        loadingDoctors={loadingDoctors}
        onConfirm={handleConfirmDoctors}
        caseId={data.id}
        bookingsMutation={bookingMutation}
        patientName={data.patient_.name} // Pass patient name
        patientPhone={data.patient_.phone} // Pass patient phone
        patientDni={data.patient_.ci} // Pass patient DNI
        bookingsData={bookingsData}
      />
      {/* Fin del popup de selección de doctores */}

      <div
        id="detallesproveedor"
        className="flex justify-content-between mb-3 mr-2"
      >
        <h3 className="mt-2 mb-2">
          {data.parent_case_id && (
            <>
              <i className="pi pi-ticket"></i> Número de Orden:{" "}
              {data.parent_case_id}
            </>
          )}
          {!data.parent_case_id && (
            <>
              <i className="pi pi-ticket"></i> Número de Orden: {data.id}
            </>
          )}
          <br></br>
          {data.service_id && (
            <span className="">
              <i className="pi pi-hashtag"></i> Siniestro: {data.service_id}
            </span>
          )}
          {data.medical_center_name && (
            <p className="m-0">
              <i className="pi pi-building-columns"></i> Proveedor:{" "}
              {data.medical_center_name}
            </p>
          )}
        </h3>
        <div className="flex gap-3 align-content-center">
          {role === UserRole.SUB_ADMINISTRATOR &&
            !data.children?.length &&
            !data.parent_medical_center && (
              <Link
                to="reasignar"
                className="p-component p-button p-button-primary font-bold"
              >
                Asignar a proveedores
              </Link>
            )}
          {(role === UserRole.MASTER || role === UserRole.CALL_CENTER || 
            (role === UserRole.MEDICAL_CENTER && data.can_change_medical_center !== false))
            &&
            [
              CaseStatus.TO_SUBSCRIBE,
              CaseStatus.PENDIENTE,
              CaseStatus.TO_REVIEW,
              CaseStatus.WITHOUT_FUNDS,
            ].includes(data.status) && (
              <>
                <Button
                  label="Cambiar proveedor"
                  icon="pi pi-building-columns"
                  onClick={() => setShowChangeMedicalCenterDialog(true)}
                />
                <ChangeMedicalCenterDialog
                  visible={showChangeMedicalCenterDialog}
                  onClose={() => {
                    if (showChangeMedicalCenterDialog)
                      setShowChangeMedicalCenterDialog(false);
                  }}
                  caseData={{
                    caseId: data.id,
                    medicalCenterName: data.medical_center_name,
                    requirements: data.requirements.map(
                      (item) => item.requirement
                    ),
                    clientId: data.company_client_id,
                  }}
                />
              </>
            )}
          {[
            CaseStatus.PENDIENTE,
            CaseStatus.RESCHEDULED,
            CaseStatus.TO_SUBSCRIBE,
          ].includes(data.status) && (
            <Link
              id="edit-case-linkg"
              to={`/casos/${data.id}/editar`}
              className="p-button p-button-link p-component p-button-raised"
            >
              Editar caso
            </Link>
          )}

          {data?.status === CaseStatus.PENDIENTE &&
            [UserRole.MEDICAL_CENTER].includes(role) && (
              <Button
                id="btn-schedule-case"
                label="Agendar Caso"
                icon="pi pi-calendar-plus"
                onClick={() => setShowDialogPending(true)}
              />
            )}

          {data?.status !== CaseStatus.REQUESTED && (
            <div id="displayg">
              <CaseDetailDisplayStatus
                caseId={data.id}
                caseStatus={isDemoMode ? localCaseStatus : selectedStatus}
              />
            </div>
          )}
          {data?.status === CaseStatus.REQUESTED && (
            <Link to="asignar-solicitud" className="p-button p-component">
              <span class="p-button-icon p-c p-button-icon-left">
                <i className="pi pi-plus"></i>
              </span>
              <span className="p-button-label p-c">Asignar Caso</span>
            </Link>
          )}
        </div>
      </div>
      <Toast ref={toastRef} position="top-center" />
      <>
        {data?.status !== CaseStatus.REQUESTED && (
          <div id="detallesdelcreador">
            <FormSubHeading title="Creador del caso" />
            <div>
              <p className="m-2">
                <i className="pi pi-user"></i> <strong>Nombre:</strong>{" "}
                {data.creator_user.first_name} {data.creator_user.last_name}
                <Button
                  icon="pi pi-comment"
                  link
                  className="p-0 w-fit ml-3"
                  label="Enviar mensaje"
                  onClick={() => {
                    navigate("/chat", {
                      state: { user: data.creator_user },
                    });
                  }}
                />
              </p>
              <p className="m-2">
                <i className="pi pi-envelope"></i> <strong>Email:</strong>{" "}
                {data.creator_user.email}
              </p>
              {data.creator_user.phone_number && (
                <p className="m-2">
                  <i className="pi pi-phone"></i> <strong>Teléfono:</strong>{" "}
                  {data.creator_user.phone_number}
                </p>
              )}
            </div>
          </div>
        )}
      </>
      <div className="flex justify-content-between">
        <div className="m-1 flex-1">
          <div id="detallesdelpaciente">
            <FormSubHeading title="Datos del paciente" />

            <p className="m-2">
              <i className="pi pi-id-card"></i> <strong>Cédula:</strong>{" "}
              {formatCi(data.patient_.ci)}
            </p>
            <p className="m-2">
              <i className="pi pi-address-book"></i> <strong>Nombre:</strong>{" "}
              {data.patient_.name}
            </p>
            <p className="m-2">
              <i className="pi pi-phone"></i> <strong>Teléfono:</strong>{" "}
              {formatFullNumber(data.patient_.phone)}
            </p>
            <p className="m-2">
              <i className="pi pi-phone"></i> <strong>Otro Teléfono:</strong>{" "}
              {formatFullNumber(data.patient_.optional_phone)}
            </p>
            <p className="m-2">
              <i className="pi pi-phone"></i> <strong>Teléfono Fijo:</strong>{" "}
              {data.holder_.landline_phone}
            </p>
            <p className="m-2">
              <i className="pi pi-calendar"></i>{" "}
              <strong>Fecha de Nacimiento:</strong>{" "}
              {formatDateString(data.patient_.birthdate)}
              {!!data.patient_age && ` (${data.patient_age} años)`}
            </p>
            <p className="m-2">
              <i className="pi pi-user"></i> <strong>Sexo:</strong>{" "}
              {readableSex(data.patient_.sex)}
            </p>
          </div>
        </div>
        <div className="m-1 flex-1">
          <div id="detallesdelservicio">
            <FormSubHeading title="Datos del caso y servicios" />

            <p className="m-2">
              <i className="pi pi-briefcase"></i>{" "}
              <strong>
                {data.insurance_name === "Vértice Seguros"
                  ? "Colectivo:"
                  : "Filial:"}
              </strong>{" "}
              {data.subsidiary_name}
            </p>
            {data.diagnosis_name && (
              <p className="m-2">
                <i className="pi pi-wave-pulse"></i>{" "}
                <strong>Diagnóstico:</strong> {data.diagnosis_name}
              </p>
            )}
            {data.medical_center_name && (
              <p className="m-2">
                <i className="pi pi-building-columns"></i>{" "}
                <strong>Proveedor:</strong> {data.medical_center_name}
              </p>
            )}
            {data?.state_name && (
              <>
                <p className="m-2">
                  <i className="pi pi-map-marker"></i> <strong>Estado:</strong>{" "}
                  {data.state_name}
                </p>
                <p className="m-2">
                  <i className="pi pi-map-marker"></i> <strong>Ciudad:</strong>{" "}
                  {data.city_name}
                </p>
                <p className="m-2">
                  <i className="pi pi-map-marker"></i>{" "}
                  <strong>Dirección:</strong> {data.address}
                </p>
              </>
            )}
            {data.schedule_date && (
              <p className="m-2">
                <i className="pi pi-calendar"></i>{" "}
                <strong>Fecha de atención:</strong>{" "}
                {new Date(Date.parse(data.schedule_date)).toLocaleDateString(
                  "es-ES",
                  {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  }
                )}
              </p>
            )}

            {data.external_order_id && (
              <p className="m-2">
                <i className="pi pi-hashtag"></i>{" "}
                <strong>Número de orden:</strong> {data.external_order_id}
              </p>
            )}

            {data.medical_order && (
              <Link
                to={data.medical_order}
                target="_blank"
                className="p-button p-button-success font-bold"
              >
                <span className="p-button-icon p-button-icon-left">
                  <i className="pi pi-external-link"></i>
                </span>
                <span className="p-button-label">Ver orden médica</span>
              </Link>
            )}
            {!data.medical_order &&
              [
                UserRole.MASTER,
                UserRole.CALL_CENTER,
                UserRole.LABORATORY,
              ].includes(role) && (
                <>
                  <Button
                    label="Agregar orden médica"
                    icon="pi pi-upload"
                    className="w-fit"
                    onClick={() => setShowMedicalOrderDialog(true)}
                  />
                  <MedicalOrderDialog
                    show={showMedicalOrderDialog}
                    onHide={() => {
                      if (showMedicalOrderDialog)
                        setShowMedicalOrderDialog(false);
                    }}
                    caseId={data.id}
                  />
                </>
              )}
            {/* Botón Imprimir Caso */}
            {/* @todo mostrar boton cuando se termine la conexion con el dll */}
            {/* <div>
              <Button
                label="Imprimir Orden"
                icon="pi pi-print"
                className="w-fit mt-2 p-button-warning"
                severity="warning"
                loading={printingOrder}
                disabled={printingOrder}
                onClick={() => handlePrintExternalOrder(data, toastRef)}
              />
            </div> */}
            {/* <p className="m-2">
              <i className="pi pi-money-bill"></i> <strong>Monto:</strong> Bs.{" "}
              {currencyFormat(data.amount)}
            </p> */}
          </div>
        </div>
      </div>
      <FormSubHeading title="Datos del titular" />
      <div>
        <p>
          <i className="pi pi-id-card"></i> <strong>Cédula:</strong>{" "}
          {formatCi(data.holder_.ci)}
        </p>
      </div>

      {data.status !== CaseStatus.REQUESTED && (
        <>
          <FormSubHeading
            title={
              role === UserRole.SUB_ADMINISTRATOR
                ? "Requerimientos del caso"
                : "Tilda los servicios atendidos y descarga el compromiso"
            }
          />
          <div>
            <DetailRequirementsTable
              value={dataRequirements}
              showDoneColumn={data.status !== "anulado"}
              requirementsDone={requirementsDone}
              changeRequirementDone={changeRequirementDone}
              caseStatus={data.status}
              currency={
                data.medical_center_currency ||
                data.parent_case_currency ||
                "Bs."
              }
              medicalCenterId={data.medical_center}
              clientId={data.company_client_id}
              subAdministratorId={data.parent_medical_center}
              insuranceName={data.insurance_name}
              currentRequirements={data.requirements.map(
                (req) => req.requirement
              )}
              parentMedicalCenter={data.parent_medical_center}
              bookingsData={bookingsDataState}
              data={data}
            />

            <div className="flex justify-content-between mb-3">
              {role !== UserRole.SUB_ADMINISTRATOR && (
                <Button
                  label="Ver Citas asignadas"
                  icon="pi pi-eye"
                  className="max-w-max mt-3 mb-3"
                  onClick={() => setShowDoctorSelectionModal(true)} // Abrir el modal
                />
              )}

              {/* @change SOLVED BUG BY REPLACING IF LOGIC
              WITH CLASSNAME HIDDEN, FOR SOME REASON
              USING IF CONDITION TO REMOVE COMPONENT IF THE
              CONDITIONS ARE NOT MET RETURNS A removeChild exception 
              This happens when you change the status to 'atendido'
              or 'anulado' */}

              {/* Controla la visibilidad del botón y el tooltip */}
              {(() => {
                const showAttendButton =
                  role !== UserRole.ANALYST_COMPANY_CLIENT &&
                  role !== UserRole.ANALYST_SUPPLIER &&
                  role !== UserRole.SUB_ADMINISTRATOR &&
                  (data.status === CaseStatus.PENDIENTE ||
                    data.status === CaseStatus.RESCHEDULED);

                return (
                  /*<Button
                id="btn-attend-case"
                {...(showAttendButton
                  ? {
                      tooltip: "Marcar servicios para atender",
                      tooltipOptions: {
                        position: "top",
                        showOnDisabled: true,
                        disabled: requirementsDone.filter((r) => r.is_done)
                          .length,
                      },
                    }
                  : {})}
                severity="success"
                className={`max-w-max mt-3 ${
                  !showAttendButton ? "hidden" : ""
                }`}
                icon="pi pi-save"
                label="Marcar como atendido"
                disabled={!requirementsDone.length}
                onClick={() => {
                  setShowReqDoneDialog(true);
                }}
              /> */

                  /*<Button
                id="btn-attend-case"
                {...(showAttendButton
                  ? {
                      tooltip: isDemoMode 
                        ? "Simular marcado como atendido (Modo Demo)" 
                        : "Marcar servicios para atender",
                      tooltipOptions: {
                        position: "top",
                        showOnDisabled: true,
                        disabled: requirementsDone.filter((r) => r.is_done).length,
                      },
                    }
                  : {})}
                severity="success"
                className={`max-w-max mt-3 ${!showAttendButton ? "hidden" : ""}`}
                icon="pi pi-save"
                label={isDemoMode ? "Simular atendido (Demo)" : "Marcar como atendido"}
                disabled={isDemoMode ? false : !requirementsDone.length}
                onClick={() => {
                  if (isDemoMode) {
                    // Simulación del modo demo
                    setLocalCaseStatus(CaseStatus.ATENDIDO);
                    toastRef.current.show({
                      severity: "success",
                      summary: "Éxito (Demo)",
                      detail: "Caso marcado como atendido en modo demostración",
                      life: 3000
                    });
                    
                    // Simular requisitos completados
                    const simulatedRequirementsDone = requirementsDone.map(req => ({
                      ...req,
                      is_done: true
                    }));
                    changeRequirementDone(simulatedRequirementsDone);
                  } else {
                    // Comportamiento normal
                    setShowReqDoneDialog(true);
                  }
                }}
              />*/

                  // 1. Añade un nuevo estado para controlar el diálogo demo

                  // 2. Modifica el botón para cambiar su comportamiento

                  <Button
                    id={
                      isDemoAttended ? "btn-compromiso-demo" : "btn-attend-case"
                    }
                    {...(showAttendButton
                      ? {
                          tooltip: isDemoMode
                            ? isDemoAttended
                              ? "Ver compromiso simulado"
                              : "Marcar como atendido (Modo Demo)"
                            : "Marcar servicios para atender",
                          tooltipOptions: {
                            position: "top",
                            showOnDisabled: true,
                            disabled: isDemoMode
                              ? false
                              : requirementsDone.filter((r) => r.is_done)
                                  .length,
                          },
                        }
                      : {})}
                    severity="success" // Siempre verde
                    className={`max-w-max mt-3 ${
                      !showAttendButton ? "hidden" : ""
                    }`}
                    icon={
                      isDemoMode && isDemoAttended ? "pi pi-eye" : "pi pi-save"
                    }
                    label={
                      isDemoMode
                        ? isDemoAttended
                          ? "Ver Compromiso (Demo)"
                          : "Marcar como atendido (Demo)"
                        : "Marcar como atendido"
                    }
                    disabled={isDemoMode ? false : !requirementsDone.length}
                    onClick={() => {
                      if (isDemoMode) {
                        if (isDemoAttended) {
                          // Comportamiento de "Ver Compromiso"
                          toastRef.current.show({
                            severity: "info",
                            summary: "Modo Demo",
                            detail: "Mostrando compromiso simulado",
                            life: 3000,
                          });
                        } else {
                          // Mostrar diálogo de confirmación
                          setOriginalStatus(localCaseStatus);
                          setShowDemoDialog(true);
                        }
                      } else {
                        setShowReqDoneDialog(true);
                      }
                    }}
                  />
                );
              })()}

              {isDemoMode && showDemoDialog && (
                <Dialog
                  id="demo-dialoggg"
                  header="Simulación - Marcar como atendido (Demo)"
                  visible={true}
                  style={{ maxWidth: "35rem" }}
                  onHide={() => {
                    setShowDemoDialog(false);
                    setLocalCaseStatus(originalStatus);
                  }}
                  draggable={false}
                >
                  <div className="p-fluid text-center">
                    <p>
                      Estás en modo demostración. Esta acción simulará marcar
                      los servicios como atendidos.
                    </p>
                    <p>
                      <b>
                        Estado simulado: de <StatusTag value={originalStatus} />{" "}
                        a <StatusTag value={CaseStatus.ATENDIDO} />
                      </b>
                    </p>
                  </div>
                  <div className="delete-confirm-buttons-container">
                    <Button
                      label="Confirmar simulación"
                      id="btn-confirm-demo"
                      severity="success"
                      icon="pi pi-check"
                      onClick={() => {
                        setLocalCaseStatus(CaseStatus.ATENDIDO);
                        const simulatedRequirementsDone = requirementsDone.map(
                          (req) => ({
                            ...req,
                            is_done: true,
                          })
                        );
                        changeRequirementDone(simulatedRequirementsDone);
                        setIsDemoAttended(true); // Marcar como atendido en demo
                        toastRef.current.show({
                          severity: "success",
                          summary: "Simulación exitosa",
                          detail: "Caso marcado como atendido (Modo Demo)",
                          life: 3000,
                        });
                        setShowDemoDialog(false);
                      }}
                    />
                    <Button
                      label="Cancelar"
                      severity="secondary"
                      onClick={() => {
                        setShowDemoDialog(false);
                        setLocalCaseStatus(originalStatus);
                      }}
                    />
                  </div>
                </Dialog>
              )}
            </div>

            <RoleWrapper
              denyRoles={[
                UserRole.ANALYST_COMPANY_CLIENT,
                UserRole.ANALYST_SUPPLIER,
              ]}
              userRole={userRole}
            >
              {showCompromiso && !notAtentStatuses.includes(data.status) && (
                <div className="flex justify-content-end mb-3">
                  <Button
                    id="btn-compromiso"
                    severity="success"
                    className="max-w-max mt-3"
                    icon="pi pi-external-link"
                    label="Ver Compromiso"
                    disabled={!requirementsDone.length}
                    onClick={() => {
                      window.open(
                        `${BASE_URL}insurance/medical-case-compromise/${data.id}/`
                      );
                    }}
                  />
                </div>
              )}
            </RoleWrapper>

        {/* data.client_fund_type == "postpay" */}
        <RoleWrapper
          allowedRoles={[UserRole.MEDICAL_CENTER, UserRole.MASTER]}
          userRole={userRole}
        >
          <div className="flex justify-content-end mb-3">
            {!data.service_id &&
              (data.client_fund_type === "postpay" ||
                data.company_client_name === "PDVSA") &&
              data.status === CaseStatus.ATENDIDO && (
                <Button
                  severity="success"
                  label="Generar siniestro"
                  icon="pi pi-file"
                  className="mt-3 ml-2 max-w-max align-self-end"
                  onClick={() => {
                    generateClaimMutation.mutate({ caseId: data.id });
                    setShowGenerateClaimDialog(true);
                  }}
                />
              )}
          </div>
        </RoleWrapper>
      </div>

      {/* if */}
      <RoleWrapper
        denyRoles={[UserRole.ANALYST_COMPANY_CLIENT]}
        userRole={userRole}
      >
        {(![CaseStatus.PENDIENTE, CaseStatus.RESCHEDULED].includes(
          data.status
        ) ||
          (isDemoMode && isDemoAttended)) &&
        showCompromiso ? (
          <>
            <div id="facturag" style={{ marginBottom: "10px" }}>
              <FormSubHeading title="Factura" />

                  {role !== UserRole.ANALYST_SUPPLIER && (
                    <>
                      <label className="mb-2">
                        El tamaño máximo permitido es 1MB
                        {isDemoMode && " (Modo Demo)"}
                      </label>
                      <Messages ref={msgs} />
                      <FileUpload
                        disabled={
                          isDemoMode
                            ? false
                            : data.status === CaseStatus.ANULADO
                        }
                        name="file"
                        mode="basic"
                        chooseLabel={
                          isDemoMode
                            ? "Cargar factura (Demo)"
                            : data.status === CaseStatus.ANULADO
                            ? "No disponible"
                            : "Cargar factura"
                        }
                        onSelect={
                          isDemoMode
                            ? () => {
                                toastRef.current.show({
                                  severity: "info",
                                  summary: "Modo Demo",
                                  detail: "Simulando carga de factura",
                                  life: 2000,
                                });
                              }
                            : undefined
                        }
                        url={
                          isDemoMode
                            ? undefined
                            : `${BASE_URL}insurance/medical-case-invoice/`
                        }
                        auto
                        accept=".jpeg,.jpg,.png,.pdf"
                        onBeforeUpload={({ formData, xhr }) => {
                          formData.append("medical_case", data.id);
                          console.log(xhr.response);
                          const reqListener = (r) => {
                            console.log("rrr", r);
                            console.log(r.target.response);
                            // convert the JSON string to a JSON object
                            const data = JSON.parse(r.target.response);
                            console.log(data);
                            setInvoice((prev) => [
                              ...prev,
                              {
                                file: data.file,
                                fileName: data.file_name,
                                id: data.id,
                              },
                            ]);
                          };
                          xhr.addEventListener("load", reqListener);
                        }}
                        onUpload={isDemoMode ? handleDemoUpload : onUpload}
                        onBeforeSend={(e) => {
                          console.log("onBeforeSend", e);
                        }}
                        onValidationFail={(file) => {
                          if (file.size > 1000000) {
                            msgs.current.show([
                              {
                                sticky: true,
                                severity: "error",
                                summary: "Tamaño de archivo inválido",
                                detail: "El tamaño máximo permitido es 1MB",
                              },
                            ]);
                            return;
                          }
                        }}
                        maxFileSize={1000000}
                      />
                    </>
                  )}
                </div>
                {!!invoice.length && (
                  <DataTable stripedRows value={invoice} className="mt-2">
                    <Column
                      header="Vista previa"
                      body={invoiceFilePreviewBody}
                    />
                    <Column header="Nombre" body={medicalFileNameLinkBody} />
                    <Column header="Acción" body={medicalFileActionBody} />
                  </DataTable>
                )}

                <div className="btn-agregarsoporte">
                  <FormSubHeading title="Cargar soportes médicos" />
                  {role !== UserRole.ANALYST_SUPPLIER && (
                    <Button
                      label={
                        isDemoMode
                          ? "Agregar soporte (Demo)"
                          : "Agregar soporte"
                      }
                      onClick={() => {
                        if (isDemoMode) {
                          // Mostrar modal de demo
                          setShowFileDialog(true);
                          toastRef.current.show({
                            severity: "info",
                            summary: "Modo Demo",
                            detail: "Simulando carga de soporte médico",
                            life: 2000,
                          });
                        } else {
                          setShowFileDialog(true);
                        }
                      }}
                      icon="pi pi-file-arrow-up"
                      className="max-w-max"
                      disabled={
                        isDemoMode
                          ? false
                          : data.status === CaseStatus.ANULADO ||
                            medicalFiles.length > 0
                      }
                    />
                  )}
                </div>

                {/* Modal original - solo se muestra cuando NO está en demo mode */}
                {!isDemoMode && (
                  <MedicalFileDialog
                    show={showFileDialog}
                    onHide={() => setShowFileDialog(false)}
                    onSave={onSaveMedicalFile}
                    onUpload={onUpload}
                    caseId={data.id}
                    requirements={dataRequirements}
                  />
                )}

                {/* Modal de demo - solo se muestra en demo mode */}
                {isDemoMode && showFileDialog && (
                  <Dialog
                    header="Cargar soporte médico (Demo)"
                    visible={true}
                    style={{ minWidth: "35rem" }}
                    onHide={() => setShowFileDialog(false)}
                    draggable={false}
                  >
                    <div className="p-fluid">
                      <p>
                        Debe cargar <b>un solo archivo</b> que soporte los
                        siguientes requerimientos:
                      </p>
                      <ul>
                        {dataRequirements
                          .filter((r) => r.is_done)
                          .map((req) => (
                            <li key={req.id}>
                              {Number(req.quantity).toFixed(0)}{" "}
                              {req.requirement_name} ({req.type_requirement})
                            </li>
                          ))}
                      </ul>

                      {/* Área de carga simulada idéntica a la imagen */}
                      <div className="p-fileupload ">
                        <div className="p-fileupload-content">
                          <Button>
                            <i className="pi pi-plus p-button-icon-left"></i>
                            <span className="p-button-label">
                              Elegir archivo
                            </span>
                          </Button>
                        </div>
                        <div className="p-fileupload-content">
                          <p className="p-m-0" style={{ color: "#6c757d" }}>
                            Cargar Informe o Estudios
                          </p>
                        </div>
                      </div>

                      <Button
                        label="Confirmar (Demo)"
                        icon="pi pi-upload"
                        id="btn-confirmg"
                      />
                    </div>
                  </Dialog>
                )}
              </>
            ) : null}
          </RoleWrapper>

          <div className="mb-4">
            {!!medicalFiles.length && (
              <DataTable stripedRows value={medicalFiles} className="mt-2">
                <Column header="Vista previa" body={invoiceFilePreviewBody} />
                <Column header="Nombre" body={medicalFileNameLinkBody} />
                <Column header="Acción" body={medicalFileActionBody} />
              </DataTable>
            )}
          </div>

          <div className="flex justify-content-end">
            <div className="flex flex-column align-items-center">
              {/* Cambiar estado:{" "} */}
              {/* <StatusSelector
                currentStatus={data.status}
                selectedStatus={selectedStatus}
    
                disabled={true}
                onChange={(e) => {
                  if (e.value === "pendiente") {
                    toastRef.current.show({
                      severity: "error",
                      summary: "Error",
                      detail: "No se puede cambiar a estado pendiente",
                    });
                    return;
                  }
                  if (e.value === CaseStatus.REMESADO && !invoiceFile && !medicalFiles.length) {
                    toastRef.current.show({
                      severity: "error",
                      summary: "Error",
                      detail: "Debe subir la factura y el soporte médico para remsesar el caso",
                    });
                    return;
                  }
                  setSelectedStatus(e.value);
                  setShowDialog(true);
                }}
              /> */}
            </div>
          </div>

          {data.status === CaseStatus.CONCILIADO &&
            (role === UserRole.MASTER || role === UserRole.MEDICAL_CENTER) && (
              <div>
                <FormSubHeading title="Documentos de Conciliación" />
                <div className="mb-4">
                  {conciliationFiles.length > 0 ? (
                    <DataTable
                      stripedRows
                      value={conciliationFiles}
                      className="mt-2"
                    >
                      <Column
                        header="Vista previa"
                        body={invoiceFilePreviewBody}
                      />
                      <Column header="Nombre" body={medicalFileNameLinkBody} />
                      <Column
                        header="Acción"
                        body={conciliationFileActionBody}
                      />
                    </DataTable>
                  ) : (
                    <div className="flex flex-column align-items-center gap-3 p-4 border-round border-1 surface-border">
                      <p>No hay documentos cargados</p>
                      {/* 👇 Aquí es donde necesitas llamar a handleFileUpload */}
                      {role === UserRole.MASTER && (
                        <div>
                          <input
                            type="file"
                            id={`file-upload-conciliate`}
                            accept=".pdf,.jpeg,.jpg,.png"
                            style={{ display: "none" }}
                            onChange={(e) => handleFileUpload(e, {})} // Puedes pasar un objeto vacío como row
                          />

                          <Button
                            label="Cargar Documento"
                            icon="pi pi-upload"
                            onClick={() =>
                              document
                                .getElementById("file-upload-conciliate")
                                .click()
                            }
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}

          <div className="w-100 flex flex justify-content-start">
            {(role === UserRole.CALL_CENTER || role === UserRole.MASTER) &&
              data.status === CaseStatus.TO_SUBSCRIBE && (
                <Button
                  icon="pi pi-bell"
                  label="Suscribir"
                  severity="warning"
                  onClick={() => {
                    // set timeout

                    suscribeCaseToPendingMutation.mutate({
                      caseId: data.id,
                    });
                  }}
                  loading={suscribeCaseToPendingMutation.isPending}
                  disabled={suscribeCaseToPendingMutation.isPending}
                  className="mt-3 ml-2 max-w-max align-self-end"
                />
              )}

            {(role === UserRole.CALL_CENTER ||
              role === UserRole.MASTER ||
              role === UserRole.MEDICAL_CENTER ||
              role === UserRole.LABORATORY ||
              role === UserRole.SUB_ADMINISTRATOR) && (
              <Button
                icon="pi pi-times"
                label="Anular Caso"
                onClick={() => setShowAnullateDialog(true)}
                severity="danger"
                className="mt-3 ml-2 max-w-max align-self-start"
                disabled={
                  !(
                    data.status === CaseStatus.PENDIENTE ||
                    data.status === CaseStatus.RESCHEDULED ||
                    data.status === CaseStatus.TO_SUBSCRIBE ||
                    data.status === CaseStatus.WITHOUT_FUNDS ||
                    (data.status === CaseStatus.ATENDIDO &&
                      role !== UserRole.MEDICAL_CENTER)
                  )
                }
              />
            )}

            {data.status === CaseStatus.ATENDIDO &&
              showCompromiso &&
              role !== UserRole.ANALYST_COMPANY_CLIENT &&
              role !== UserRole.ANALYST_SUPPLIER &&
              role !== UserRole.SUB_ADMINISTRATOR && (
                <Button
                  icon="pi pi-save"
                  label={isDemoMode ? "Remesar (Demo)" : "Remesar"}
                  onClick={() => {
                    // if ((!invoice.length && !invoiceFile) || !medicalFiles.length) {
                    //   toastRef.current.show({
                    //     severity: "error",
                    //     summary: "Error",
                    //     detail:
                    //       "Debe subir la factura y el soporte médico para remesar el caso",
                    //   });
                    //   return;
                    // }
                    setShowRemesadoDialog(true);
                  }}
                  severity="success"
                  className="mt-3 ml-2 max-w-max align-self-end"
                  disabled={data.status === CaseStatus.ANULADO}
                />
              )}
            {isDemoMode && isDemoAttended && (
              <Button
                id="btn-remesar-demog"
                icon="pi pi-save"
                label="Remesar (Demo)"
                onClick={() => setShowRemesadoDialog(true)}
                severity="success"
                className="mt-3 ml-2 max-w-max align-self-end"
              />
            )}

            <div className="btn-conc">
              {data.status === CaseStatus.REMESADO &&
                role === UserRole.MASTER && (
                  <Button
                    icon="pi pi-check-circle"
                    label={"Conciliar"}
                    style={{
                      backgroundColor: "#7e22ce",
                      border: "None",
                      color: "white",
                    }}
                    onClick={() => setShowConciliarDialog(true)}
                    severity="info"
                    className="mt-3 ml-2 max-w-max align-self-end"
                  />
                )}
            </div>
          </div>

          <div className="w-100 flex flex justify-content-end"></div>
        </>
      )}

      {/* if */}

      {/* Requirements done modal */}
      {role !== UserRole.SUB_ADMINISTRATOR && (
        <Dialog
          header="Marcar servicios como atendidos"
          visible={showReqDoneDialog}
          style={{ maxWidth: "35rem" }}
          onHide={() => {
            if (showReqDoneDialog) setShowReqDoneDialog(false);
          }}
          draggable={false}
        >
          <div className="p-fluid text-center">
            <p>
              <b>
                Esto cambiará el estado del caso de{" "}
                <StatusTag value={selectedStatus} /> a{" "}
                <StatusTag value={CaseStatus.ATENDIDO} />
              </b>
            </p>

            {/* Lista de servicios NO marcados */}

            {unmarkedRequirements.length > 0 && (
              <>
                <p>
                  <strong>⚠️ Alerta:</strong> Estos servicios aún NO están
                  marcados como atendidos:
                </p>
                <div
                  className="mt-3 border-1 surface-border p-2 border-round"
                  style={{ maxHeight: "200px", overflowY: "auto" }}
                >
                  <ul
                    className="requirement-list mt-2 mb-2 pl-3 pr-3"
                    style={{ textAlign: "left" }}
                  >
                    {unmarkedRequirements.map((req) => (
                      <li key={req.id} className="p-1">
                        <span>{req.name}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <p className="mt-3">¿Deseas continuar igualmente?</p>
              </>
            )}

            {unmarkedRequirements.length === 0 && (
              <p>Todos los servicios han sido marcados como atendidos.</p>
            )}
          </div>
          <br></br>
          <div className="delete-confirm-buttons-container">
            <Button
              id="btn-confirm-requirements-done"
              type="button"
              label="Confirmar"
              loading={requirementsDoneMutation.isPending}
              disabled={requirementsDoneMutation.isPending}
              onClick={() => {
                const doneRequirements = requirementsDone.map((req) => {
                  return {
                    ...req,
                    is_done: true,
                  };
                });
                requirementsDoneMutation.mutate({
                  caseId: data.id,
                  doneRequirements: doneRequirements,
                });
              }}
            />
            <Button
              type="button"
              label="Cancelar"
              style={{ backgroundColor: "#999999", borderColor: "#999999" }}
              disabled={requirementsDoneMutation.isPending}
              onClick={() => {
                if (showReqDoneDialog) setShowReqDoneDialog(false);
              }}
            />
          </div>
        </Dialog>
      )}

      <ConciliarCaseDialog
        show={showConciliarDialog}
        onHide={() => {
          if (showConciliarDialog) setShowConciliarDialog(false);
        }}
        caseMutation={caseMutation}
        caseId={data.id}
        onFileUploaded={(newFile) =>
          setConciliationFiles((prev) =>
            Array.isArray(prev) ? [...prev, newFile] : [newFile]
          )
        } //
      />

      {/* Modal Remesado */}
      <RemesarCaseDialog
        show={showRemesadoDialog}
        onHide={() => {
          if (showRemesadoDialog) setShowRemesadoDialog(false);
        }}
        caseMutation={caseMutation}
        caseId={data.id}
        isDemoMode={isDemoMode} // Pasar el estado demo
        setIsDemoMode={setIsDemoMode} // Pasar el setter
      />

      {/* Modal for confirming case status change */}
      <ChangeStatusSingleModal
        rowChanging={data}
        newStatus={selectedStatus}
        show={showDialog}
        onHide={() => {
          if (showDialog) setShowDialog(false);
        }}
        onSave={() => {
          caseMutation.mutate({
            caseId: data.id,
            data: { status: selectedStatus },
          });
        }}
      />

      {/* Modal Anullate */}
      <AnnullateCaseDialog
        show={showAnullateDialog}
        onHide={() => {
          if (showAnullateDialog) setShowAnullateDialog(false);
        }}
        caseMutation={caseMutation}
        caseId={data.id}
      />

      {/* Modal Subscribe */}
      <Dialog
        header="Suscripción"
        visible={showSubscribeDialog}
        style={{ maxWidth: "35rem" }}
        onHide={() => {
          if (showSubscribeDialog) setshowSubscribeDialog(false);
        }}
        draggable={false}
      >
        <div className="p-fluid text-center">
          <p>{messageSubscribeResponse}</p>
        </div>
        <br></br>
        <div className="delete-confirm-buttons-container">
          <Button
            type="button"
            label="Aceptar"
            style={{ backgroundColor: "#999999", borderColor: "#999999" }}
            onClick={() => {
              if (showSubscribeDialog) setshowSubscribeDialog(false);
            }}
          />
        </div>
      </Dialog>

      <GenerateClaimDialog
        visible={showGenerateClaimDialog}
        onHide={() => {
          setShowGenerateClaimDialog(false);
        }}
        caseId={data.id}
        responseMessage={responseSiniestroMessage}
        loading={generateClaimMutation.isPending}
      />
    </div>
  );
}

/**
 * Modal para cargar orden médica
 * @param {Object} props
 * @param {boolean} props.show
 * @param {() => void} props.onHide
 * @param {number} props.caseId
 */
function MedicalOrderDialog({ show, onHide, caseId }) {
  const [medicalOrder, setMedicalOrder] = useState(null);

  const toast = useContext(ToastContext);

  const queryClient = useQueryClient();

  const medicalOrderMutation = useMutation({
    mutationFn: addMedicalOrderToCase,
    onSuccess: ({ type, message }) => {
      if (type === "error") {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: message,
        });
      } else {
        toast.current.show({
          severity: "success",
          summary: "Éxito",
          detail: message,
        });
        queryClient.invalidateQueries({
          queryKey: ["medicalCase", Number(caseId)],
        });
        onHide();
      }
    },
  });

  return (
    <Dialog
      visible={show}
      onHide={() => {
        if (!medicalOrderMutation.isPending) onHide();
      }}
      header="Agregar orden médica"
      draggable={false}
      className="md:w-5"
    >
      <div className="p-fluid">
        <div className="p-field">
          <label htmlFor="medicalOrder">Seleccione el archivo:</label>
          <input
            type="file"
            id="medicalOrder"
            name="medicalOrder"
            className="w-full surface-100 p-2 cursor-pointer p-component p-input border-round-md border-1 border-200 mb-2 mt-1"
            onChange={(e) => setMedicalOrder(e.target.files?.[0])}
          />
        </div>
        <div className="flex justify-content-end">
          <Button
            label="Guardar orden médica"
            icon="pi pi-save"
            className="w-fit"
            disabled={!medicalOrder || medicalOrderMutation.isPending}
            loading={medicalOrderMutation.isPending}
            onClick={() =>
              medicalOrderMutation.mutate({ caseId, medicalOrder })
            }
          />
        </div>
      </div>
    </Dialog>
  );
}

/**
 * Displays requirements of case in a table
 */
function DetailRequirementsTable({
  value,
  showDoneColumn,
  requirementsDone,
  changeRequirementDone,
  caseStatus,
  currency = "Bs.",
  medicalCenterId,
  clientId,
  subAdministratorId,
  insuranceName,
  currentRequirements,
  parentMedicalCenter,
  bookingsData,
  data
}) {
  const [showAddRequirement, setShowAddRequirement] = useState(false);

  // Get requirement types
  const role = localStorage.getItem("role");
  const isAdmin = localStorage.getItem("isAdmin") === "true";

  const canAddRequirements = useCanAddRequirementsToCase(medicalCenterId, {
    enabled:
      (role === UserRole.MEDICAL_CENTER || role === UserRole.LABORATORY) &&
      !isAdmin,
    initialData: false,
  });

  const canAddRequirementsCallCenter = useCanAddRequirementsCallCenter(
    undefined,
    clientId,
    {
      enabled:
        (role === UserRole.CALL_CENTER || role === UserRole.MASTER) &&
        !isAdmin &&
        !!clientId,
      select: (data) => data?.can_add_requirements || false,
    }
  );

  const addRequirementButton = () =>
    (canAddRequirements.data || canAddRequirementsCallCenter.data) && (
      <Button
        label="Agregar requerimiento"
        icon="pi pi-plus"
        className="max-w-fit"
        onClick={() => setShowAddRequirement(true)}
        disabled={
          caseStatus !== CaseStatus.PENDIENTE &&
          caseStatus !== CaseStatus.RESCHEDULED
        }
      />
    );

  const serviceTemplate = (row) => {
    // console.log("bookingsData", bookingsData);
    // Buscar el booking correspondiente al requerimiento
    const booking = bookingsData?.find(
      (booking) => booking.requirement_id === row.id
    );

    return (
      <div className="flex align-items-center gap-2">
        <span>{row.requirement_name}</span>
        {booking && (
          <span className="text-sm text-gray-600">
            {" - "}
            {booking.doctor_name} |{" "}
            {new Date(booking.date).toLocaleDateString("es-ES")}{" "}
            {new Date(booking.date).toLocaleTimeString("es-ES", {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
        )}
      </div>
    );
  };

  const quantityTemplate = (item) => (
    <InputNumber
      disabled={
        caseStatus !== CaseStatus.RESCHEDULED ||
        role !== UserRole.MEDICAL_CENTER ||
        !["ODONTOLOGÍA", "ODONTOLOGIA"].includes(item.type_requirement)
      }
      placeholder="Cantidad..."
      value={item.quantity}
      min={1}
      className="w-5"
      onChange={(e) => {
        // const result = value
        //   .map((itemValue) => {
        //     if (itemValue.requirement !== item.requirement) {
        //       const updatedItem = requirementsDone.find(
        //         (newItem) => newItem.requirement === itemValue.requirement
        //       );
        //       return updatedItem ? updatedItem : null;
        //     }
        //     return {
        //       ...itemValue,
        //       is_done: true,
        //       quantity: e.value,
        //     };
        //   })
        //   .filter((itemValue) => itemValue !== null);
        // changeRequirementDone(result);
        // changeRequirementDone(
        //   value
        //     .map((v) => {
        //       if (v.requirement !== item.requirement) {
        //         const doneReq = requirementsDone.find(
        //           (r) => r.requirement === v.requirement
        //         );
        //         if (doneReq) return doneReq;
        //         return null;
        //       }
        //       return {
        //         ...v,
        //         is_done: true,
        //         quantity: e.value,
        //       };
        //     })
        //     .filter((v) => v !== null)
        // );
        // setQuantities((prev) => ({
        //   ...prev,
        //   [item.id]: e.value,
        // }));
      }}
    />
  );

  /*
   * Calculate totales de los requerimientos
   
  const thisAmountTotal = () => {
    const result = value.filter((requirement) =>
      requirementsDone.some(
        (doneRequirement) =>
          doneRequirement.requirement === requirement.requirement
      )
    );
    const total = result?.reduce(
      (accumulator, requirement) =>
        accumulator +
        Number(requirement.amount) * Number(requirement.quantity || 1),
      0
    );
    return currencyFormat(total);
  };*/

  const thisAmountTotal = () => {
  // Filtrar requisitos que están en requirementsDone
    const result = value.filter((requirement) =>
      requirementsDone.some(
        (doneRequirement) =>
          doneRequirement.requirement === requirement.requirement
      )
    );

    // Calcular el total, usando dynamic_amount si se cumplen las condiciones
    const total = result?.reduce((accumulator, requirement) => {
      const shouldUseDynamic =
        data?.client_fund_type === "postpay" &&
        data?.status === CaseStatus.ATENDIDO &&
        requirement.currency === "Bs";

      const amount = shouldUseDynamic
        ? requirement.dynamic_amount ?? requirement.amount // Usa dynamic_amount si existe, si no, fallback a amount
        : requirement.amount;

      const quantity = requirement.quantity || 1;

      return accumulator + Number(amount) * quantity;
    }, 0);

    return currencyFormat(total);
  };

  const useInsurance = useGetInsurance();
  const insurance = useInsurance?.data;

  const footerGroup = (
    <ColumnGroup>
      <Row>
        <Column
          footer="Total:"
          colSpan={2}
          footerStyle={{ textAlign: "right" }}
        />
        <Column footer={thisAmountTotal} />
        <Column footer={null} />
        {value.some((item) =>
          ["ODONTOLOGÍA", "ODONTOLOGIA"].includes(item.type_requirement)
        ) && <Column footer={null} />}
      </Row>
    </ColumnGroup>
  );

  const isPositiveInteger = (val) => {
    let str = String(val);

    str = str.trim();

    if (!str) {
      return false;
    }

    str = str.replace(/^0+/, "") || "0";
    let n = Math.floor(Number(str));

    return n !== Infinity && String(n) === str && n >= 0;
  };
  const onCellEditComplete = (e) => {
    console.log("OncellEdit", e);
    console.log("OnValue", value);
    let { rowData, newValue, field, originalEvent: event } = e;

    switch (field) {
      case "quantity":
        if (isPositiveInteger(newValue)) rowData[field] = newValue;
        else event.preventDefault();
        break;

      default:
        if (newValue.trim().length > 0) rowData[field] = newValue;
        else event.preventDefault();
        break;
    }
  };

  const priceEditor = (options) => {
    return (
      <InputNumber
        value={options.value}
        onValueChange={(e) => options.editorCallback(e.value)}
        onKeyDown={(e) => e.stopPropagation()}
      />
    );
  };

  const cellEditor = (options) => {
    if (options.field === "quantity") return priceEditor(options);
  };

  const isRowSelectable = (event) =>
    !(
      (caseStatus !== CaseStatus.PENDIENTE &&
        caseStatus !== CaseStatus.RESCHEDULED) ||
      role === UserRole.ANALYST_COMPANY_CLIENT ||
      role === UserRole.SUB_ADMINISTRATOR
    );

  return (
    <>
      <div className="check">
        <DataTable
          stripedRows
          value={value}
          emptyMessage="No ha registrado servicios para este proveedor"
          dataKey="requirement"
          filterDisplay="row"
          removableSort
          selectionMode={"checkbox"}
          selection={requirementsDone}
          isDataSelectable={isRowSelectable}
          onSelectionChange={(e) => {
            changeRequirementDone(e.value);
          }}
          footerColumnGroup={
            role !== UserRole.ANALYST_COMPANY_CLIENT ? footerGroup : null
          }
          editMode="cell"
        >
          <Column
            header="Servicio"
            field="requirement_name"
            body={serviceTemplate}
            sortable
            filter
            showFilterMenu={false}
            filterElement={addRequirementButton}
          />
          <Column header="Tipo de servicio" field="type_requirement" sortable />

          {role !== UserRole.ANALYST_COMPANY_CLIENT && (
            <Column
              header={
                insurance?.name === "Vértice Seguros"
                  ? "Monto REF"
                  : `Monto (${currency})`
              }
              field="amount"
              //body={(row) => currencyFormat(row.amount)}
              body={(row) => { 
                // Si es postpay y atendido, mostrar dynamic_amount
                const showDynamic = 
                  data?.client_fund_type === "postpay" &&
                  data?.status === CaseStatus.ATENDIDO &&
                  row.currency === "Bs" 
                
                return currencyFormat(showDynamic ? row.dynamic_amount : row.amount);
              }}
              sortable
            />
          )}
          {value.some((item) =>
            ["ODONTOLOGÍA", "ODONTOLOGIA"].includes(item.type_requirement)
          ) && (
            <Column
              header="Cantidad"
              field="quantity"
              body={quantityTemplate}
              key={"quantity"}
              // body={field === 'price' && priceBodyTemplate}
              editor={(options) => cellEditor(options)}
              onCellEditComplete={onCellEditComplete}
            />
          )}
          {showDoneColumn && (
            <Column
              header="¿Atendido?"
              selectionMode="multiple"
              headerStyle={{ width: "3rem" }}
              filterPlaceholder="Seleccionar todos"
            ></Column>
          )}
        </DataTable>

        <AddRequirementDialog
          show={showAddRequirement}
          onHide={() => {
            if (showAddRequirement) setShowAddRequirement(false);
          }}
          medicalCenterId={medicalCenterId}
          clientId={clientId}
          subAdministratorId={subAdministratorId}
          currentRequirements={currentRequirements}
        />
      </div>
    </>
  );
}

/**
 * Dialog para añadir requerimiento al caso
 * @param {object} props
 * @param {boolean} props.show
 * @param {() => void} props.onHide
 * @param {number} props.medicalCenterId
 * @param {number} props.clientId
 * @param {number?} props.subAdministratorId
 * @param {number[]} props.currentRequirements
 */
function AddRequirementDialog({
  show,
  onHide,
  medicalCenterId,
  clientId,
  subAdministratorId,
  currentRequirements,
}) {
  const requirements = useMedicalCenterClientRequirements({
    centerId: medicalCenterId,
    client: !!subAdministratorId ? undefined : clientId,
    subAdministrator: !!subAdministratorId ? subAdministratorId : undefined,
  });
  const [selectedRequirements, setSelectedRequirements] = useState([]);

  const { caseId } = useParams();
  const queryClient = useQueryClient();
  const toastRef = useContext(ToastContext);

  const addRequirementsMutation = useMutation({
    mutationFn: addRequirements,
    onSuccess: ({ type, message }) => {
      if (type === "success") {
        toastRef.current.show({
          severity: "success",
          summary: "Éxito",
          detail: message,
        });
        queryClient.invalidateQueries({
          queryKey: ["medicalCase", Number(caseId)],
        });
        window.location.reload();
      } else {
        toastRef.current.show({
          severity: "error",
          summary: "Error",
          detail: message,
        });
      }
    },
  });

  const closeDialog = () => {
    if (addRequirementsMutation.isPending) return;
    setSelectedRequirements([]);
    onHide();
  };

  return (
    <Dialog
      visible={show}
      onHide={closeDialog}
      header="Agregar requerimiento"
      draggable={false}
      className="md:w-5"
    >
      <div className="flex flex-column gap-1">
        <label htmlFor="new-requirement">
          Seleccione los requerimientos a agregar:
        </label>
        <MultiSelect
          id="new-requirement"
          name="new-requirement"
          showSelectAll={false}
          display="chip"
          options={
            requirements.data?.filter(
              (req) => !currentRequirements.includes(req.id)
            ) || []
          }
          value={selectedRequirements}
          onChange={(e) => setSelectedRequirements(e.value)}
          filter
          virtualScrollerOptions={{ itemSize: 40 }}
          optionValue="id"
          optionLabel="name"
          loading={requirements.isLoading}
          placeholder="Seleccionar"
          emptyMessage="No se encontraron requerimientos"
        />
        <div className="mt-2 align-self-end flex gap-2">
          <Button
            label="Cancelar"
            severity="secondary"
            onClick={closeDialog}
            disabled={addRequirementsMutation.isPending}
          />
          <Button
            label="Guardar requerimientos"
            disabled={
              selectedRequirements.length === 0 ||
              addRequirementsMutation.isPending
            }
            onClick={() => {
              addRequirementsMutation.mutate({
                caseId: Number(caseId),
                requirements: selectedRequirements.map((req) => ({
                  requirement: req,
                  is_done: false,
                })),
              });
            }}
          />
        </div>
      </div>
    </Dialog>
  );
}

/**
 * Dialog to upload a medical file
 * @param {object} props
 * @param {boolean} props.show
 * @param {() => void} props.onHide
 * @param {(state: { file: File & { objectURL: string } }) => void} props.onSave
 * @param {() => void} props.onUpload
 * @param {number} props.caseId
 */
function MedicalFileDialog({
  show,
  onHide,
  onSave,
  onUpload,
  caseId,
  requirements,
}) {
  const [formState, setFormState] = useState({
    file: null,
    fileName: "",
  });

  return (
    <Dialog
      header="Cargar soporte médico"
      visible={show}
      onHide={onHide}
      draggable={false}
      style={{ minWidth: "35rem" }}
      contentClassName="p-fluid"
    >
      <div className="p-field p-fluid">
        <span>
          Debe cargar <b>un solo archivo</b> que soporte los siguientes
          requerimientos:
        </span>
        <ul>
          {requirements
            .filter((r) => r.is_done)
            .map((req) => (
              <li key={req.id}>
                {Number(req.quantity).toFixed(0)} {req.requirement_name} (
                {req.type_requirement})
              </li>
            ))}
        </ul>
        <FileUpload
          className="mt-2"
          name="file"
          mode="advanced"
          chooseLabel="Elegir archivo"
          uploadOptions={{
            style: { display: "none" },
          }}
          cancelLabel="Cancelar"
          emptyTemplate={<p className="m-0">Cargar Informe o Estudios</p>}
          onSelect={(e) => {
            if (e.files.length) {
              setFormState({ ...formState, file: e.files[0].objectURL });
              // console.log(e.files[0].type);
            } else {
              setFormState({ ...formState, file: null });
            }
          }}
          url={`${BASE_URL}insurance/medical-case-file/`}
          auto
          accept=".jpeg,.jpg,.png,.pdf"
          onBeforeUpload={({ formData, xhr }) => {
            formData.append("medical_case", caseId);
            formData.append("type_requirement", "otro");

            const reqListener = (r) => {
              console.log(r.target.response);
              // convert the JSON string to a JSON object
              const data = JSON.parse(r.target.response);

              setFormState({
                ...formState,
                file: data.file,
                fileName: data.file_name,
                fileType: data.type_requirement,
                id: data.id,
              });
            };

            xhr.addEventListener("load", reqListener);
          }}
          onUpload={onUpload}
          maxFileSize={1000000} // 1MB
          invalidFileSizeMessageDetail="El tamaño máximo permitido es 1MB"
        />
      </div>
      <Button
        severity="success"
        label="Confirmar"
        icon="pi pi-save"
        disabled={formState.file === null}
        onClick={() => {
          onSave(formState);
          setFormState({ file: null, fileName: "" });
          onHide();
        }}
      />
    </Dialog>
  );
}

/**
 * Modal para anular caso
 * @param {object} props
 * @param {boolean} props.show
 * @param {() => void} props.onHide
 * @param {import("@tanstack/react-query").UseMutationResult} props.caseMutation
 * @param {number} props.caseId
 */
function AnnullateCaseDialog({ show, onHide, caseMutation, caseId }) {
  const [observation, setObservation] = useState("");

  const [isConfirmDisabled, setIsConfirmDisabled] = useState(true);

  useEffect(() => {
    setIsConfirmDisabled(observation.trim() === "");
  }, [observation]);

  return (
    <Dialog
      header="Anular Caso"
      visible={show}
      style={{ maxWidth: "35rem" }}
      onHide={() => {
        onHide();
        setObservation("");
      }}
      draggable={false}
    >
      <div className="p-fluid text-center">
        <p>
          <b>
            El caso cambiará a estado <StatusTag value={CaseStatus.ANULADO} />
            <br />y será asignado a otro centro médico
          </b>
        </p>
      </div>
      <div className="p-field flex flex-column">
        <label htmlFor="observation" className="w-fit">
          Observación
        </label>
        <InputTextarea
          id="observation"
          value={observation}
          onChange={(e) => setObservation(e.target.value)}
          className="mt-2"
          placeholder="Escriba una observación"
          autoResize
        />
      </div>
      <br></br>
      <div className="delete-confirm-buttons-container">
        <Button
          type="button"
          label="Confirmar"
          loading={caseMutation.isPending}
          disabled={isConfirmDisabled || caseMutation.isPending}
          onClick={() => {
            caseMutation.mutate({
              caseId: caseId,
              data: {
                status: CaseStatus.ANULADO,
                update_observation: observation,
              },
            });
          }}
        />
        <Button
          type="button"
          label="Cancelar"
          style={{ backgroundColor: "#999999", borderColor: "#999999" }}
          disabled={caseMutation.isPending}
          onClick={() => {
            onHide();
            setObservation("");
          }}
        />
      </div>
    </Dialog>
  );
}
